import { Search } from 'lucide-react'

// Illustrative list only ("these are the kinds of companies you track"). We do
// NOT attach any per-company activity facts here. v155 (SAMPLE-DATA-CLASS):
// pinning fabricated, never-refreshing "N signals today" counts on real named
// companies reads as us claiming live facts about them that we made up. Real
// names with no attached claim are fine (same as LogoMarquee); the panel is
// labelled "Sample" so it never reads as a live feed.
const TRACKED = [
  { name: 'Linear',     domain: 'linear.app'    },
  { name: 'Vercel',     domain: 'vercel.com'    },
  { name: 'Notion',     domain: 'notion.so'     },
  { name: 'Figma',      domain: 'figma.com'     },
  { name: 'Cursor',     domain: 'cursor.com'    },
  { name: 'Stripe',     domain: 'stripe.com'    },
  { name: 'Anthropic',  domain: 'anthropic.com' },
  { name: 'Datadog',    domain: 'datadoghq.com' },
  { name: 'Loom',       domain: 'loom.com'      },
  { name: 'Ramp',       domain: 'ramp.com'      },
]

export default function WatchlistDemo() {
  return (
    <div className="card-dark overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between px-5 h-12 border-b border-white/10">
        <div className="flex items-center gap-2.5">
          <span className="signal-dot" />
          <span className="text-[12px] font-semibold uppercase tracking-widest text-cream-50/90">
            Your watchlist
          </span>
        </div>
        <span className="text-[12px] uppercase tracking-widest text-cream-50/60">
          Sample
        </span>
      </div>

      {/* Static "search" bar */}
      <div className="px-5 py-3 border-b border-white/5 flex items-center gap-2">
        <Search className="w-4 h-4 text-cream-50/55 shrink-0" />
        <span className="flex-1 text-[14px] text-cream-50/55">
          Type a competitor, e.g. Notion, Stripe
        </span>
      </div>

      {/* Tracked rows: tabindex+role lets keyboard users scroll the
          list (axe: scrollable-region-focusable). aria-label gives
          screen-reader context. */}
      <ul
        className="max-h-[300px] overflow-y-auto focus:outline-none"
        tabIndex={0}
        role="list"
        aria-label="Example companies you can track"
      >
        {TRACKED.map((s) => (
          <li
            key={s.domain}
            className="flex items-center justify-between px-5 py-3 border-b border-white/5 last:border-b-0"
          >
            <div className="flex items-center gap-3 min-w-0">
              <span className="text-[14px] font-medium text-cream-50">{s.name}</span>
              <span className="text-[13px] text-cream-50/55">{s.domain}</span>
            </div>
          </li>
        ))}
      </ul>

      {/* Footer hint */}
      <div className="px-5 h-11 border-t border-white/10 bg-black/40 flex items-center justify-between">
        <span className="text-[12px] uppercase tracking-widest text-cream-50/60">
          We cover the SaaS landscape. Yours is in there.
        </span>
        <span className="text-[12px] uppercase tracking-widest text-cream-50/45">Sample</span>
      </div>
    </div>
  )
}
